module.exports = __webpack_public_path__ + "media/images/sign-in-wallpaper-41492504.jpg";